export default function init_data(IconsView, iconsViewCache) {

IconsView.prototype.loading = function (state) {
        const myself = this;
        this.isLoading = state;
        if (state) this.isLoadingDeep++;
        else this.isLoadingDeep--;
        const containers = myself.element.find('.iv__container');

        if (this.isLoadingDeep) {
            if (myself.view != 'tree' && myself.view != 'blocks') {
                if (containers.length) {
                    if (!containers.find('.iv__item--special-loading').length) {
                        myself.renderIcon(myself.options.sample.loading, containers);
                        myself.setIconSize();
                        containers.find('.iv__item--special-none').hide();
                    }
                } else {
                    if (this.options.sample) {
                        var tmpContainer = $('<div class="iv__container iv__container--tmp"></div>');
                        myself.renderIcon(this.options.sample.loading, tmpContainer);
                        this.element.find('.iv__view').append(tmpContainer);
                    }
                    else if (!this.element.find('.spinner').length) {
                        this.element.append('<div class="spinner"></div>');
                    }
                }
            }
            this.element.addClass('loading');
        } else {
            this.element.removeClass('loading');
            this.element.find('.spinner').remove();
            this.element.find('.iv__container--tmp').remove();
            if (containers) {
    	        containers.find('.iv__item--special-none').show();
    	        containers.find('.iv__item--special-loading').remove();
    	    }
        }
    };


IconsView.prototype.loadCache = function () {
        const myself = this;
        if (this.cache && iconsViewCache[this.cache]) {
            const data = jQuery.parseJSON(iconsViewCache[this.cache]);
            myself.loadAfter(data);
        } else {
            this.load();
        }
    };


IconsView.prototype.load = function () {
        const myself = this;

        if (this.element.data('url')) {
            this.dataMode = 'url';
            this.loadFromUrl(this.element.data('url'));
        } else if (this.element.data('field')) {
            this.dataMode = 'field';
            try {
                var currentData = this.dataField.val();
                if (currentData != this.dataJsonCache) {
                    this.dataJsonCache = currentData;
                    if ($.parseJSON(currentData) === '') {
                        this.dataClean = [];
                        currentData = [];
                    }
                    else {
                        this.dataClean = $.parseJSON(currentData);
                        currentData = $.parseJSON(currentData);
                    }
                    this.loadFromData(currentData);
                }
            } catch (err) {
                this.data = [];
            }
        } else if (this.data.length == 0) {
            this.dataMode = 'script';
            try {
                var currentData = $(this.element);
                if ($(this.element).find('script')) currentData = $(this.element).find('script');

                this.loadFromData($.parseJSON(currentData.html()));
            } catch (err) {
                this.data = [];
            }
        } else {
            this.dataMode = 'conf';
            myself.prepareData(myself.data, { childs: myself.data, type: 'root' });
            myself.loadPath(myself.path, true);
            myself.render();
            myself.timerLastLoad = 0;
            myself.timerLastLoadfull = 0;
        }
    };


IconsView.prototype.loadFromUrl = function (url) {
        const myself = this;
        this.loading(true);

        if (this.request) this.request.abort();
        this.request = $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',

            success(data) {
                if (myself.cache) iconsViewCache[myself.cache] = JSON.stringify(data);
                if (data.queryCount && $('.queryCount').length) $('.queryCount').html(parseInt($('.queryCount').html()) + parseInt(data.queryCount));
                myself.data = data;
                myself.loadAfter(myself.data);
                if (myself.events.load) myself.events.load(myself);
            },
            error(data, status, error) {
                myself.events.error(status);
            },
            complete(data) {
                myself.loading(false);
            },
        });
    };


IconsView.prototype.loadFromData = function (data) {
        this.loadAfter(data);
    };


IconsView.prototype.loadAfter = function (data) {
        const myself = this;
        this.data = data;
        this.dataNode = null;

        if (this.dataClean) {
            for (let i = 0; i < data.length; i++) {
                data[i].dataClean = this.dataClean[i];
            }
        }

        if (this.data.options) this.options = this.data.options;
        if (this.data.templates) this.templates = this.data.templates;
        if (this.data.types) this.types = this.data.types;
        if (this.data.id) this.rootId = this.data.id;
        if (this.data.type) this.rootType = this.data.type;
        if (this.data.data) this.data = this.data.data;

        myself.prepareOptions();

        if (data.status != 'error') {
            myself.prepareData(myself.data, { childs: myself.data, type: 'root' });

            if (myself.firstLoad) {
                if (myself.value && myself.valueType) {
                    let valuePath = myself.findPath(myself.value, myself.valueType);
                    if (valuePath && valuePath.length > 0) {
                        valuePath.pop();
                        myself.path = valuePath;
                    }
                }
                else if (myself.parent && myself.parentType) {
                    let parentPath = myself.findPath(myself.parent, myself.parentType);
                    if (parentPath && parentPath.length > 0) {
                        myself.path = parentPath;
                    }
                }
            }

            myself.loadPath(myself.path, true);
            myself.render();
            myself.firstLoad = false;
            myself.timerLastLoad = 0;
            myself.timerLastLoadfull = 0;
        } else {
            if (myself.cache) iconsViewCache[myself.cache] = null;
            myself.events.error(data);
        }
    };


IconsView.prototype.quickLoad = function (node, returnData) {
        const myself = this;
        let hasBeenLoaded = false;
        if (node && returnData && returnData.meta) {
            if (node == this.dataNodeParent) {
                // debugger;
                if (!node.path) node.path = clone(this.path);
                returnData.meta.path = clone(node.path)
                returnData.meta.path.push(this.genPathNode(returnData.meta));
                if (node.childs !== undefined && node.childs.length > 0) node.childs.push(returnData.meta);
                else node.push(returnData.meta);
                myself.prepareData([returnData.meta], node, returnData.meta.path);
                myself.loadPath(myself.path, true);
                myself.render();
                hasBeenLoaded = true;
                //myself.render(node.childs);
            }
            else {
                const newItem = returnData.meta;
                if (myself.findItem(newItem.id, newItem.type, node.parent.childs)) {
                    let oldItem = myself.findItem(newItem.id, newItem.type, node.parent.childs);
                    $.each(returnData.meta, (index, data) => {
                        if (index != 'items') {
                            if (index != 'childs' || data.length > 0) oldItem[index] = data;
                        }
                    });
                    myself.prepareData([oldItem], oldItem.parent, oldItem.path);
                    myself.loadPath(myself.path, true);
                    myself.render();
                    hasBeenLoaded = true;
                }
                else if (newItem.parent && myself.findItem(newItem.parent.id, newItem.parent.type, node.parent.childs)) {
                    let newItemParent = myself.findItem(newItem.parent.id, newItem.parent.type, node.parent.childs)
                    newItemParent.childs.push(newItem);
                    myself.prepareData([newItem], newItemParent, newItem.path);
                    myself.loadPath(myself.path, true);
                    myself.render();
                    hasBeenLoaded = true;
                }

                /*
                $.each(returnData.meta, (index, data) => {
                    if (index != 'items') {
                        if (index != 'childs' || data.length > 0) node[index] = data;
                    }
                });
                myself.prepareData([node], node.parent, node.path);
                myself.loadPath(myself.path, true);
                myself.render();
                // this.render(node.parent.childs);
                */
            }
            if (myself.events.load) myself.events.load(myself);
        }

        // Fallback online reload
        if (!hasBeenLoaded) {
            if (!node) {
                node = this.dataNodeParent;
            } else if (node.parent) {
                node = node.parent
            }
            if (node && node.load) {
                this.lazyLoad(node);
            } else {
                this.load();
            }
        }
    };


IconsView.prototype.lazyLoad = function (node) {
        const myself = this;
        const { parent } = node;
        const { index } = node;

        if (node.load) {
            if (!node.isLoading) {
                node.isLoading = true;

                this.loading(true);

                if (this.request) {
                    this.request.abort();
                }
                this.request = $.ajax({
                    url: node.load,
                    type: 'get',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',

                    success(data) {
                        if (data.queryCount && $('.queryCount').length) $('.queryCount').html(parseInt($('.queryCount').html()) + parseInt(data.queryCount));

                        if (data.status != 'error') {
                            if (Array.isArray(data.data) && data.data.length > 0) {
                                if (data.data[0] && data.data[0].id == node.id) {
                                    // Case 1: Server returned container object wrapper
                                    const serverNode = data.data[0];
                                    const origChilds = node.childs;
                                    Object.assign(node, serverNode);
                                    if (serverNode.childs) node.childs = serverNode.childs;
                                    else if (origChilds) node.childs = origChilds;
                                } else {
                                    // Case 2: Server returned array of child items directly
                                    node.childs = data.data;
                                }
                                node.loaded = true;
                            } else {
                                node.loaded = true;
                                if (!Array.isArray(node.childs)) node.childs = [];
                            }

                            let parentData = node;

                            myself.dataNodeParent = parentData;
                            myself.dataNode = parentData.childs;

                            // restore parent option
                            const newParent = clone(myself.options.sample.parent);
                            newParent.id = null;
                            if (parent && parent.id) newParent.id = parent.id;
                            if (parent && parent.type && parent.type != 'root') newParent.type = parent.type;
                            else if (myself.rootType && parent && parent.type == 'root') {
                                newParent.type = myself.rootType;
                                newParent.id = myself.rootId;
                            }
                            newParent.special = 'parent';

                            if (parentData && parentData.childs) {
                                if (parentData.childs.length && (parentData.childs[0].special === 'parent' || parentData.childs[0].label === newParent.label)) {
                                    parentData.childs[0] = newParent;
                                } else {
                                    parentData.childs.unshift(newParent);
                                }
                            }

                            myself.prepareData(parentData.childs, parentData, myself.path);
                            myself.loadPath(null, true);
                            myself.render();
                            myself.timerLastLoad = 0;

                            if (myself.events.load) myself.events.load(myself);
                        } else {
                            myself.events.error(data);
                        }
                    },
                    error(data, status, error) {
                        node.isLoading = false;
                        myself.events.error(status);
                    },
                    complete(data) {
                        node.isLoading = false;
                        myself.loading(false);
                    },
                });
            }
        }
    }


IconsView.prototype.refreshTree = function () {
        const myself = this;
        this.element.find('.iv__item').each(function () {
            const item = $(this);
            if (item.find('.iv__item').length > 0) item.addClass('iv__item--parent');
            else item.removeClass('iv__item--parent');
        })
    }


IconsView.prototype.save = function () {
        if (this.element.data('field')) {
            this.dataField.val(JSON.stringify(this.dataClean)).change();
            this.load();
        }
    }


IconsView.prototype.update = function (data, path) {
        if (!path) {
            this.data = data;
        } else {
            _.set(this.dataClean, path, data);
            // _.set(this.data, path, data);
        }
        this.render();
        this.save();
    };


IconsView.prototype.prepareData = function (data, parentDataAll, path) {
        const myself = this;

        // no items
        if (parentDataAll.type == 'root' && data && Array.isArray(parentDataAll.childs) && myself.options.sample && myself.options.sample.root) {
            if (parentDataAll.childs.length && parentDataAll.childs[0] && parentDataAll.childs[0].special === 'root') {
                parentDataAll.childs[0] = clone(myself.options.sample.root);
            } else {
                parentDataAll.childs.unshift(clone(myself.options.sample.root));
            }
        }

        const parentData = parentDataAll;
        const currentData = data;
        if (!path) path = [];

        // actions remap
        if (parentDataAll) {
            if (!parentDataAll.actions) {
                parentDataAll.actions = {};
            }
            if (this.types[parentDataAll.type]) {
                if (this.types[parentDataAll.type].actions) {
                    mergeToObject(this.types[parentDataAll.type].actions, parentDataAll.actions);
                }

                if (this.types[parentDataAll.type].default && !parentDataAll.special) {
                    parentDataAll.default = this.types[parentDataAll.type].default;
                }
            }

            parentDataAll.actions = Object.assign({}, parentDataAll.actions);
            $.each(parentDataAll.actions, (indexAction, action) => {
                if (!action) return true;
                let replaceIndex = false;
                if (parseInt(indexAction) > 0 || parseInt(indexAction) === 0) replaceIndex = true;
                if (typeof action === 'string') {
                    if (myself.options.actions && myself.options.actions[action]) {
                        if (replaceIndex) {
                            delete parentDataAll.actions[indexAction];
                            indexAction = action;
                        }
                        parentDataAll.actions[indexAction] = myself.options.actions[action];
                    } else {
                        delete parentDataAll.actions[indexAction];
                    }
                }
            });

            // no type, no actions use all defined actions
            if (!Object.keys(parentDataAll.actions).length && !parentDataAll.type && myself.options.actions) {
                parentDataAll.actions = myself.options.actions;
            }
        }

        if (data) {
            $.each(data, (index, data) => {
                if (data) {
                    data.index = index;
                    data.parent = parentData;
                    data.path = path;

                    // is selected
                    if (myself.firstLoad) {
                        $.each(myself.go, (selectionIndex, selectionItem) => {
                            // is selected
                            if (data.id && selectionItem.id == data.id && selectionItem.type == data.type && !data.special) {
                                myself.path = path;
                                myself.path.push({ field: 'id', value: data.id, type: data.type });
                            }
                        });

                        $.each(myself.selection, (selectionIndex, selectionItem) => {
                            if (myself.options.value) {
                                // compare value infos
                                if (data && data[myself.options.value] && data[myself.options.value] == selectionItem.id && !data.special) {
                                    if (data.id) {
                                        myself.selection[selectionIndex] = {
                                            id: data.id,
                                            type: data.type,
                                            data,
                                        };
                                    }
                                    data.selected = true;
                                    myself.path = path;
                                }
                            } else {
                                // is selected
                                if (data.id && selectionItem.id == data.id && selectionItem.type == data.type && !data.special) {
                                    data.selected = true;
                                    myself.path = path;
                                    selectionItem.data = data;
                                }
                            }
                        });
                    }


                    // childs process
                    if (data.childs) {
                        const newParent = clone(myself.options.sample.parent);
                        newParent.id = null;
                        if (parentData.id && parentData.type !== 'root') {
                            newParent.id = parentData.id;
                            newParent.type = parentData.type;
                        } else {
                            newParent.id = myself.rootId || null;
                            newParent.type = myself.rootType || 'character';
                        }
                        newParent.special = 'parent';
                        if (data.childs && data.childs.length && (data.childs[0].special === 'parent' || data.childs[0].label === newParent.label)) {
                            data.childs[0] = newParent;
                        }
                        else if (data.childs && data.childs.unshift) {
                            data.childs.unshift(newParent);
                        }
                        var currentPath = path.concat([{
                            field: 'id',
                            value: data.id,
                        }]);
                        myself.prepareData(data.childs, data, currentPath);
                    } else {
                        myself.prepareData(null, data, currentPath);
                    }
                }
            });
        }
    };


IconsView.prototype.prepareOptions = function () {
        if ((!this.options || !this.options.length) && this.conf.options) this.options = this.conf.options;
        if ((!Object.keys(this.templates).length) && this.conf.templates) this.templates = this.conf.templates;

        for (const i in this.templates) {
            if (!this.templates[i].view) this.templates[i].view = [];
            if (!this.templates[i].view.modes) {
                this.templates[i].view.modes = [
                    'icons',
                    'mosaic',
                    'thumbnails',
                    'list',
                    'table',
                    'summary',
                ];
            }
        }

        // default options array
        if (!this.options) this.options = {};
        if (!this.options.template) this.options.template = 'default';
        if (!this.options.event) this.options.event = {};
        if (!this.options.features) this.options.features = {};
        if (!this.options.request) this.options.request = {};
        if (!this.options.sample) this.options.sample = {};
        if (!this.options.expand && !this.options.expand !== false) this.options.expand = false;

        // Samples
        // Parent item
        this.options.sample.parent = {
            id: 'parent',
            icon: (this.conf.parent.icon) ? this.conf.parent.icon : 'arrow-do-undo',
            label: this.conf.parent.label,
            selectable: false,
            type: 'parent',
            special: 'parent',
            default: 'parent',
            sticky: 100,
            actions: {
                parent: {
                    action: 'browseParent',
                    icon: this.conf.parent.icon,
                    label: this.conf.parent.label,
                },
            },
        }
        this.options.sample.root = {
            id: null,
            icon: (this.conf.root.icon) ? this.conf.root.icon : 'place-home',
            label: this.conf.root.label,
            selectable: false,
            type: 'root',
            special: 'root',
            sticky: 200,
        }
        this.options.sample.none = {
            id: null,
            icon: (this.conf.none && this.conf.none.icon) ? this.conf.none.icon : 'status-warning',
            label: this.conf.none.label,
            selectable: false,
            type: 'none',
            special: 'none',
            sticky: 99,
        }
        this.options.sample.loading = {
            id: null,
            icon: (this.conf.loading && this.conf.loading.icon) ? this.conf.loading.icon : 'fa-spinner-third',
            label: 'Chargement...',
            selectable: false,
            type: 'none',
            special: 'loading',
            sticky: 99,
        }
        this.options.sample.default = {
            id: null,
            icon: (this.conf.default && this.conf.default.icon) ? this.conf.default.icon : 'file-page-empty',
        }

        // events
        if (!this.data.events) this.data.events = {};

        this.events = {};
        if (this.conf.events) {
            if (this.conf.events.error) this.events.error = this.conf.events.error;
            if (this.conf.events.edit) this.events.edit = this.conf.events.edit;
            if (this.conf.events.refreshInput) this.events.refreshInput = this.conf.events.refreshInput;
            if (this.conf.events.render) this.events.render = this.conf.events.render;
            if (this.conf.events.change) this.events.change = this.conf.events.change;
            if (this.conf.events.load) this.events.load = this.conf.events.load;
        }

        // Features
        if (!this.options.features.lockSelection && this.options.features.lockSelection !== false) this.options.features.lockSelection = false;
        if (!this.options.features.breadcrumb && this.options.features.breadcrumb !== false) this.options.features.breadcrumb = 'auto';
        if (!this.options.features.sortable && this.options.features.sortable !== false) this.options.features.sortable = false;
        if (!this.options.features.droppable && this.options.features.droppable !== false) this.options.features.droppable = false;
        if (!this.options.features.reorganize && this.options.features.reorganize !== false) this.options.features.reorganize = true;
        if (!this.options.features.bgUnselect && this.options.features.bgUnselect !== false) this.options.features.bgUnselect = true;

        // Events
        this.options.event.backup = null;
        if (!this.options.event.leftClick) this.options.event.leftClick = 'action';
        if (!this.options.event.rightClick) this.options.event.rightClick = 'menu';
        if (!this.options.event.doubleClick) this.options.event.doubleClick = null;
        if (!this.options.event.shiftClick) this.options.event.shiftClick = 'selectInt';
        if (!this.options.event.ctrlClick) this.options.event.ctrlClick = 'select';
        if (!this.options.event.altClick) this.options.event.altClick = 'select1';

        // Map
        if (!this.options.remap) this.options.remap = {};
        if (!this.options.remap.label) this.options.remap.label = ['label'];
        if (!this.options.remap.icon) this.options.remap.icon = ['icon'];

        // Misc
        if (!this.order && this.options.order) this.order = this.options.order;
    };


}
